module.exports = __webpack_public_path__ + "img/jackpot.f827a96c.png";